import React from 'react';
import {
    Col,
    Row
} from 'antd';
import top1 from '../../images/top1.png'
import top2 from '../../images/top2.png'
import top3 from '../../images/top3.png'




class List extends React.Component {
    render() {
        return <>
            <div className='thead'>
                <Row>
                    {this.theadRender()}
                </Row>
            </div>

            <ul className='tbody'>
                {this.tBodyRender()}
            </ul>
        </>
    }
    theadRender = () => {
        const {
            sort = false,
            columns = []
        } = this.props
        let span = [9, 5, 5, 5]
        const arr = [...columns]
        if (sort) {
            span = [3, 6, 5, 5, 5]
            arr.unshift({
                name: "排名",
                render: (val, row, index) => {

                },
            })
        }
        return <>
            {arr.map(function (item, index) {
                return <Col span={span[index]} key={item.name}>
                    <div style={{
                        textAlign: item.align || 'center'
                    }}>
                        {item.name}
                    </div>
                </Col>
            })}
        </>
    }
    tBodyRender = () => {
        const _this = this
        const {
            sort = false,
            columns = [],
            dataSource = []
        } = this.props
        let span = [9, 5, 5, 5]
        const arr = [...columns]
        if (sort) {
            span = [3, 6, 5, 5, 5]
            arr.unshift({
                name: "排名",
                render: (val, row, index) => {
                    if (index <= 2) {
                        const imgarr = [top1, top2, top3]
                        return <div style={{
                            textAlign: "center"
                        }}><img src={imgarr[index]} alt=" " /></div>
                    }
                    return <div style={{
                        textAlign: "center"
                    }}>{index + 1}</div>
                },
            })
        }
        return <>{dataSource.map(function (item, index) {
            return <li key={item.name} className='list_item'><Row >
                {_this.tdRender(arr, item, index, span)}
            </Row></li>
        })}</>
    }
    tdRender = (columns = [], row = {}, index, span) => {
        return <>{columns.map(function (item = {}, ydex) {
            let result = item.dataIndex && row[item.dataIndex]
            if (item.render) {
                result = item.render(result, row, index)
            }
            return <Col span={span[ydex]} key={item.name}>
                {result}
            </Col>
        })}</>
    }
}


export default List